import { useEffect, useState } from 'react';
import styles from './ProofPopup.module.sass';
import 'animate.css';

export default function ProofPopup({ data }) {
  // STATE
  const [index, setIndex] = useState(0);
  const [animation, setAnimation] = useState(null);
  const [isOff, setOff] = useState(false);
  const [shownCount, setShownCount] = useState(0);

  // VARS
  const item = data[index];
  // Random delay around 30s between popups
  const showTime = 10000;

  function getRandomDelay(min = 25000, max = 35000) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  // EFFECTS
  useEffect(() => {
    if (!data.length || isOff || shownCount >= 5) return;

    const delay = getRandomDelay(25000, 35000);
    const showTimer = setTimeout(() => {
      showPopup(index);
    }, delay);

    const hideTimer = setTimeout(() => {
      hidePopup(index);
    }, delay + showTime);

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, data.length, isOff, shownCount]);

  // UTILS
  function showPopup(index) {
    if (data[index]) {
      setAnimation('animate__fadeInUp');
    }
  }

  function hidePopup(index) {
    setAnimation('animate__fadeOutDown');

    setTimeout(() => {
      const nextIndex = data[index + 1] ? index + 1 : 0;
      setShownCount((c) => {
        const next = c + 1;
        if (next < 5) {
          setIndex(nextIndex);
        } else {
          // stop after 5 popups
          setAnimation(null);
        }
        return next;
      });
    }, 500);
  }

  // RENDER
  if (!animation || isOff) return null;

  return (
    <div className={`${styles.popup} animate__animated ${animation} animate__faster`}>
      <div className={styles.close} onClick={() => setOff(true)}>
        <i className='far fa-times-circle'></i>
      </div>
      <div className={styles.image}>
        <img src={item.image} width={70} height={70} alt={item.product} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>
          {item.name} from {item.city}
        </div>
        <div className={styles.text}>purchased {item.product}</div>
        <div className={styles.date}>{item.date}</div>
        <div className={styles.link}>
          <i className='fas fa-check-circle'></i> by <span>{item.company}</span>
        </div>
      </div>
    </div>
  );
}
